import styled from 'styled-components';
import { devices } from '@src/styles/theme';
import KakaoMessageIcon from '@src/assets/imgs/kakaoIcon.svg';

/** 피플 카카오톡 채널 상담 */
const KAKAO_CHANNEL_CHAT_URL = 'https://pf.kakao.com/_RixjiX/chat';

/**
 * 전 페이지에 뜨는 카카오톡 상담 버튼.
 *
 * 위치는 우측 하단 고정. 같은 자리를 쓰는 '맨 위로' 버튼(right: 100px)과
 * 겹치지 않게 우측 끝에 두고, 모바일에서는 하단 고정 바(상세 액션바·목록 필터 FAB)에
 * 가리지 않도록 조금 띄운다.
 */
const FloatingKaKaoButton = () => (
  <Container
    href={KAKAO_CHANNEL_CHAT_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="카카오톡으로 문의하기"
  >
    <Button>
      <KaKaoIcon />
    </Button>
  </Container>
);

export default FloatingKaKaoButton;

const Container = styled.a`
  display: flex;
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 60;
  @media ${devices.tablet} {
    right: 16px;
    /* 모바일 하단 고정 바(약 84px)를 피한다 */
    bottom: 96px;
  }
`;

const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 52px;
  height: 52px;
  cursor: pointer;
  overflow: hidden;
  box-shadow: rgba(63, 71, 77, 0.25) 0px 2px 10px;
  background-color: #fee500;
  transition: transform 0.15s;
  &:hover {
    transform: translateY(-2px);
  }
`;

/**
 * 카카오톡 말풍선(메시지) 아이콘.
 * 기존 kakao.svg 는 288x257 래스터가 박힌 로고라 52px 원 안에서 뭉개진다.
 * 벡터 말풍선 아이콘을 노란 원 위에 얹는다.
 */
const KaKaoIcon = styled(KakaoMessageIcon)`
  width: 26px;
  height: 24px;
`;
